import { memo } from 'react';
import { formatBytes } from 'utils';

import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from './style';

interface Props {
  files: File[];
  removeFile?: (name: string) => void;
}

const FilesList: React.FC<Props> = ({ files, removeFile }) => {
  const classes = useStyles();

  return (
    <ul className={classes.ul}>
      {files.map((file) => {
        return (
          <li className={classes.li} key={file.name}>
            <div className={classes.leveler}>
              <span className={classes.name}>{file.name}</span>
            </div>
            <div className={classes.flex}>
              <span className={classes.size}>{formatBytes(file.size)}</span>
              {removeFile ? (
                <Button
                  onClick={() => removeFile(file.name)}
                  classes={{ root: classes.button }}
                >
                  <CloseIcon className={classes.icon} />
                </Button>
              ) : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default memo(FilesList);
